// extracted by mini-css-extract-plugin
module.exports = {"richtextPreview":"RichTextPreview_richtextPreview__pBiOC"};